import React, { PropTypes } from 'react';
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell, Text, Label, LabelList} from 'recharts';

export default class BarChartView extends React.Component {
  constructor(props) {
    super(props);
    // set state
    this.state = {
      data: [],
      width: 550,
      height: 200,
    };
  }

  componentWillReceiveProps(newProps) {
    let width = newProps.data.length > 10 ? 800 : 550;
    this.setState({
      data: newProps.data,
      type: newProps.type,
      height:  300,
      classId: newProps.classId,
      width: width,
    })
  }

  handleClick = (data, index) => {
    if (this.props.type == 'photos' || this.props.type == 'videos') {
      this.props.handleClickBar(data.class_id, data.class_name)
    }
  }

  render() {
    return (
     <BarChart width={this.state.width} height={this.state.height} data={this.state.data} 
            margin={{top: 20, right: 0, left: 0, bottom: 0}}>
         <YAxis type="number" tick={{fontSize: '13px'}}/>
         <XAxis dataKey="class_name" type="category" tick={{fontSize: '12px'}}/>
        <Bar dataKey="teacher_count" label={{ fill: '#C08C00', fontSize: 14, position: 'top', dx: 10, dy: -5 }} barSize={20} onClick={this.handleClick}>
          {
            this.state.data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.class_id == this.state.classId ? "#FF8888" : "#FFE247"}/>
            ))
          }
        </Bar>
        <Bar dataKey="parent_count" label={{ fill: '#C08C00', fontSize: 14, position: 'top' , dx: 10, dy: -5}} barSize={20}>
          {
            this.state.data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill="#7D93DC" />
            ))
          }
        </Bar> 
      </BarChart>
    )
  }
}









// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/share/BarChartView.jsx